import type { CSSProperties } from "react";

// Reveal order of a .v2-reveal element (delay = i x --v2-stagger). Plain module: callable from server components.
export const stagger = (i: number) => ({ "--i": i }) as CSSProperties;
